export const initialAction = 
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
(watchContext, baseUrl = '', preloadedConfig) => (dispatch) => {
    const promises = [];
    const { didomiNoticeId } = preloadedConfig;
    promises.push(dispatch({
        type: 'didomi/success',
        payload: {
            didomiNoticeId,
        },
    }));
    return Promise.all(promises);
};
